import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account creato! Benvenuta su Velyrea");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-72px)] grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <div className="w-full max-w-sm">
          <h1 className="font-serif text-3xl mb-1">Crea il tuo account</h1>
          <p className="text-charcoal/50 mb-8 text-sm">Salva i tuoi profili e i tuoi look preferiti</p>
          <form onSubmit={submit} className="space-y-4">
            <input required placeholder="Nome" value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" className="w-full border-b border-rose-200 py-3 focus:outline-none focus:border-rose-500 bg-transparent" />
            <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" className="w-full border-b border-rose-200 py-3 focus:outline-none focus:border-rose-500 bg-transparent" />
            <input type="password" required minLength={6} placeholder="Password (min 6 caratteri)" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" className="w-full border-b border-rose-200 py-3 focus:outline-none focus:border-rose-500 bg-transparent" />
            <button disabled={loading} data-testid="register-submit" className="w-full rounded-full bg-rose-400 hover:bg-rose-500 text-white font-semibold py-3 transition-colors disabled:opacity-60">
              {loading ? "..." : "Registrati"}
            </button>
          </form>
          <div className="my-5 flex items-center gap-3 text-xs text-charcoal/40"><div className="flex-1 h-px bg-rose-100" />oppure<div className="flex-1 h-px bg-rose-100" /></div>
          <button onClick={google} data-testid="google-register-btn" className="w-full flex items-center justify-center gap-2.5 border border-rose-200 rounded-full py-3 font-medium hover:bg-rose-50 transition-colors">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> Continua con Google
          </button>
          <p className="mt-6 text-center text-sm text-charcoal/60">Hai già un account? <Link to="/login" className="text-rose-500 font-semibold" data-testid="to-login">Accedi</Link></p>
        </div>
      </div>
      <div className="hidden lg:block relative rose-gold-bg order-1 lg:order-2">
        <div className="absolute inset-0 flex flex-col justify-center px-16 text-white">
          <img src="/velyrea-logo.png" alt="Velyrea" className="h-16 w-16 mb-6 brightness-0 invert opacity-90" />
          <h2 className="font-serif text-5xl leading-tight">Discover Your<br />Perfect Beauty</h2>
          <p className="mt-4 text-white/90 max-w-md">Migliaia di prodotti consigliati su misura, gratis. Unisciti a Velyrea.</p>
        </div>
      </div>
    </div>
  );
}
